import { render, staticRenderFns } from "./StoresOfMerchant.vue?vue&type=template&id=40e42acc&scoped=true&"
import script from "./StoresOfMerchant.vue?vue&type=script&lang=js&"
export * from "./StoresOfMerchant.vue?vue&type=script&lang=js&"
import style0 from "./StoresOfMerchant.vue?vue&type=style&index=0&id=40e42acc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e42acc",
  null
  
)

export default component.exports